import { c as _c } from "react/compiler-runtime";
import { LoadingSkeleton } from 'design-system/server';
export default function SectionContentPlaceholder() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <>{new Array(3).fill(null).map(_temp)}</>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(_, index) {
  return <LoadingSkeleton key={index} height="16px" width="150px" style={{
    paddingBlock: "var(--betterplace-sizing-200)"
  }} />;
}